import * as R from 'ramda'

import fetchProductPrice from '../../../../models/modules/fetchProductPrice.js'
import printExcel from '../../../../models/modules/printExcel.js'

// handle product price
async function findProductPrice({ value: skuDoc, path }, ctx) {
  const doc = ctx.getDoc()
  const { pricebookRef: pricebookDoc } = doc

  const { bookPriceDoc } = await fetchProductPrice(
    { skuDoc, pricebookDoc },
    ctx,
  )

  const bookPrice = R.propOr(0, 'price', bookPriceDoc)
  const price = bookPrice

  const itemPath = R.dropLast(1, path)
  ctx.mergePath({ path: itemPath, value: { price } })
}
function changePricebook(spec, ctx) {
  const items = R.path(['items'], ctx.getDoc())

  // TODO fetch prices in one api.get
  ctx.resetPath({ path: ['items'], value: items })
}

function downloadExcel(s, ctx) {
  const { doc } = ctx
  const { key, sellerRef } = doc
  const filename = `${key}_${sellerRef.key}.xlsx`
  printExcel({ doc, filename, template: 'purchaseReqForm' })
}

export default {
  watcher: {
    pricebookRef: { name: 'changePricebook' },
    'items.0.skuRef': { name: 'findProductPrice' },
  },
  actions: {
    downloadExcel: {
      text: '列印',
      effect: { name: 'downloadExcel' },
      props: { variant: 'outlined', color: 'primary' },
      hotkey: 'ctrl+p',
    },
    saveAndCopy: {
      authChecker: () => null,
    },
  },
  effect: {
    findProductPrice,
    changePricebook,
    downloadExcel,
  },
}
